import {createActorContext} from '@xstate/react';

import {fhsMachine} from '../../machine/fhs.machine';

export const FhsContext = createActorContext(fhsMachine);
